import { Action } from "../../../common/actions/core/action";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { ActionHandler } from "../../../common/actions/core/action-handler";
import { ListeningPackageSegment } from "../../../common/services/package/package.model";
import MobileService from "../../../common/services/mobile.service";
import { NoAuthBuySuccessAction } from "./buy-success-dialog.action";

/* @ngInject */
export default class NoAuthBuySuccessDialogController implements ActionHandler {
  private dialogElement;
  protected isMobile: boolean = false;
  private type: ListeningPackageSegment;

  constructor(
    protected $element,
    private $window,
    protected actionDispatcher: ActionDispatcherService,
    protected mobileService: MobileService,
    private config,
    private i18n
  ) { }

  public $postLink() {
    this.dialogElement = this.$element.find('#no-auth-buy-success-dialog').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof NoAuthBuySuccessAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  protected onListen() {
    let webPlayer = this.config.webPlayer.tr;
    webPlayer =webPlayer +
      (webPlayer.indexOf('?') !== -1
        ? '&language=' + this.i18n.getCurrentLanguage()
        : '?language=' + this.i18n.getCurrentLanguage());

    this.$window.open(webPlayer, '_self');
  }

  protected startListen() {
    this.$window.open('https://fizy.in/Ps93n', '_self');
  }

  private openDialog() {
    this.dialogElement.open();
    if (this.mobileService.isMobile()) {
      this.isMobile = true;
    }
  }

  public isStandartMessageSegment() {
    return !this.isAudioBookSegment() && !this.isPremiumPlusSegment();
  }

  public isAudioBookSegment() {
    return this.type === ListeningPackageSegment.SESLI;
  }

  public isPremiumPlusSegment() {
    return (
      this.type === ListeningPackageSegment.BUNDLE_SESLI ||
      this.type === ListeningPackageSegment.BUNDLE_AUDIOBOOK ||
      this.type === ListeningPackageSegment.BIREYSEL_SESLI
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/buy-success-dialog/buy-success-dialog.controller.ts